import dayjs from 'dayjs'

export const TRIAL_DAYS = 14

export const getTrialDaysLeft = (trialEndDate: string | Date) => {
  const date = dayjs(trialEndDate)
  return Math.ceil(date.diff(dayjs(), 'day', true))
}
